export default "__VITE_ASSET__A4P25asK__"